'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './survey-edit.routes';

export class SurveyEditComponent {

  constructor(Auth, dialogs, SurveysService, $uibModal, $state, $location, Config, $stateParams, Upload, StorageService, $q) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.Auth = Auth;
    this.Upload = Upload;
    this.StorageService = StorageService;
    this.$location = $location;
    this.SurveysService = SurveysService;
    this.$q = $q;
    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["h3","h4","h5"],
      ["p", "clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["archiveImageLink", "insertImage", "insertLink"],
      ["backgroundColor","fontColor","fontName", "fontSize"]
    ];

    this.roles = Config.getPlatformConfig().getPermissionRoles();

    this.checkedRoles = {};
    this.roles.forEach(role => {this.checkedRoles[role] = false});

    this.questionTypes = ["text","select-one","select-many"];

    this.surveyId = $stateParams.id;

    this.statusTypes = ["draft","open","closed"];

    this.restrictionTypes = [{
      label: "None (Survey can be taken multiple times)",
      type: "none"
    }, {
      label: "Once per User",
      type: "user"
    }, {
      label: "Once per Unit/Lot",
      type: "unit"
    }];

    this.assets = [];

    if (this.surveyId) {
      this.SurveysService.get({id: this.surveyId}, survey => {
        this.survey = survey;
        this.assets = survey.attachments;
        this.survey.settings.roles.forEach(role => {this.checkedRoles[role] = true});
      });
    } else {
      this.survey = {
        status: 'draft',
        settings: {
          onlyCertainRoles: false,
          roles: [],
          restriction: 'none'
        },
        questions: [{
          type: 'text'
        }]
      };
    }

    this.sortableOptions = {
        handle: '.handle'
    };

    var that = this;

    this.dropHandler = function( file, insertAction ) {

      var isImage = that.isImageMime(file.type);
      var isPdf = that.isPdfMime(file.type);

      // validation
      if( !isImage && !isPdf) {
        // ignore other file than images and pdfs
        return;
      }

      /* could check for file size: if( file.size > 500000 ) */

      var defer = that.$q.defer();

      that.Upload.upload({
        url: '/api/storage',
        data: {
          name: file.name,
          file: file,
          storageStrategy: 'local',
          isPublic: true,
          creationUser: that.Auth.getCurrentUserSync()._id,
          active: true
        }
      }).then((response) => {

        if (isImage) {
          insertAction( "insertImage", "/api/storage/public/" + response.data, true );
          defer.resolve(true);
        } else if (isPdf) {
          that.StorageService.getMeta({id: response.data}, data => {
            that.assets.push(data);
            defer.resolve(true);
          }, err => {
            console.log('could not retrieved storage from server');
            defer.reject();
          });
        }

      }, (response) => {
        if (response.status > 0) {
          alert(response.status + ': ' + response.data);
          defer.reject();
        }
      });

      return defer.promise;

    };

  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  removeAsset(idx) {
    this.assets.splice(idx,1);
  }

  openAssetBrowserModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {
        that.assets = that.assets.concat(newlySelectedAssets);
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'application/pdf,image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {
          that.StorageService.getMeta({id: storageId}, data => {
            that.assets.push(data);
          }, err => {
            console.log('could not retrieved storage from server');
          });

        });

      },
      function () { /* cancel */ }
    );

  }


  addQuestion() {
    this.survey.questions.push({
      type: 'text'
    });
  }

  removeAnswer(question, idx) {
    question.answers.splice(idx,1);
  }

  addAnswer(question) {
    if (!question.hasOwnProperty("answers")) {
      question.answers = [""];
    } else {
      question.answers.push("");
    }
  }

  deleteQuestion($event, question, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Question?", "Do you really want to delete the following question: <br/><br/>" + question.question);
    dlg.result.then(() => {
      this.survey.questions.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  create(form) {

    /* Replace all newlines with html breaks, before saving
    this.types.forEach(type => {
      this.data[type].forEach(section => {
        if (section.detail.about) {
          section.detail.about = section.detail.about.split(/\n/).join("<br/>");
        }
      })
    });*/

    let action = (this.surveyId) ? "changed" : "created";

    var onSuccess = (data) => {
      let dlg = this.dialogs.notify("Success", "The survey has been " + action + " successfully");
      dlg.result.then(() => {
        this.$state.go("survey-list");
      });

    };

    var onError = err => {
      this.dialogs.error("Error","There has been an error trying to save the settings");
    };

    this.survey.attachments = this.assets.map(asset => {
      return asset._id;
    });

    if (this.survey.settings.onlyCertainRoles) {
      this.survey.settings.roles = this.roles.filter(role => this.checkedRoles[role]);
    } else {
      this.survey.settings.roles = [];
    }

    if (this.survey.settings.restriction == 'none') {
      this.survey.settings.canBeChanged = false;
    }

    if (this.surveyId) {
      this.SurveysService.update({id: this.survey._id}, this.survey, onSuccess, onError);
    } else {
      this.SurveysService.save(this.survey, onSuccess, onError);
    }
  }

}

export default angular.module('conduuApp.surveyEdit', [uiRouter])
  .config(routes)
  .component('surveyEdit', {
    template: require('./survey-edit.html'),
    controller: SurveyEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/edit/survey-edit.component.js